import { render, staticRenderFns } from "./ViewStatistics.vue?vue&type=template&id=bb7cd1f6&scoped=true&"
import script from "./ViewStatistics.vue?vue&type=script&lang=ts&"
export * from "./ViewStatistics.vue?vue&type=script&lang=ts&"
import style0 from "./ViewStatistics.vue?vue&type=style&index=0&id=bb7cd1f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7cd1f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
